<!--
<doc lang="markdown">
</doc>


<style scoped lang="scss">
</style>


<template lang="pug">
</template>
-->

<script>
  // "Herança" direta, mantendo a estrutura isolada (arquivos)
  import InputField from '../desktop/input-field.vue'
  export default InputField
</script>
